import {getActionLocation} from '../../../../utils/edap';

const getOptions = (config, i18n) => {
    const {
        url: {
            prefix
        },
        site: {
            name: siteName,
            domain
        },
        template
    } = config;

    const {
        locale
    } = i18n;

    const searchQuerySubmittedEventActionLocation = getActionLocation(template);

    const systemOptions = {
        site: siteName,
        baseUrl: `https://${domain}`,
        appPrefix: prefix,
        locale
    };

    const edapOptions = {
        searchQuerySubmittedEventActionLocation
    };

    const datesOptions = {
        dateFormatOptions: {
            day: 'numeric',
            month: 'short',
            weekday: 'short'
        }
    };

    return {
        systemOptions,
        edapOptions,
        datesOptions
    };
};

const getSettings = (config) => {
    const {
        isMobile,
    } = config;

    const mediaSettings = {
        isMobile
    };

    return {
        mediaSettings
    };
};

const getTranslations = (labels) => {
    const {
        typeahead,
        datePicker,
        guests,
        buttonTitle: labelText
    } = labels;

    const {
        destinationplaceholdermsg: placeholderMessage,
        destinationselected: selectedMessage,
        noresultsfound: noResultsFoundMessage,
        recentlyviewed: recentlyViewedLabel,
        recentsearches: recentSearchesMessage,
        resultsfound: resultsFoundMessage,
        trendingdestinations: trendingDestinationsMessage,
        typeairport: typeAirportLabel,
        typecity: typeCityLabel,
        typelandmark: typeLandmarkLabel,
        typemetrostation: typeMetroStationLabel,
        typeneighborhood: typeNeighborhoodLabel,
        typeregion: typeRegionLabel,
        typetrainstation: typeTrainStationLabel,
        where: whereLabel
    } = typeahead;

    const {
        modalCheckIn: modalTitleStartDateMessage,
        checkIn: startDateLabel,
        checkOut: endDateLabel,
        modalCheckOut: modalTitleEndDateMessage,
        done: datesContinueButtonLabel,
        close: datesCloseButtonLabel,
        labels: datesClearButtonLabel
    } = datePicker;

    const {
        adult: adultText,
        adults: adultsText,
        applyBtn: guestsApplyButtonLabel,
        child: childText,
        children: childrenText,
        guest: guestText,
        guests: guestsText,
        label: guestsLabel,
        mobileBtn: guestsContinueButtonLabel,
        modalTitle: guestsModalTitle,
        noBtn: petNoLabel,
        petMessage,
        pets: petsText,
        yesBtn: petYesLabel
    } = guests;

    const destinationTranslations = {
        noResultsFoundMessage,
        placeholderMessage,
        recentSearchesMessage,
        recentlyViewedLabel,
        resultsFoundMessage,
        selectedMessage,
        trendingDestinationsMessage,
        typeAirportLabel,
        typeCityLabel,
        typeLandmarkLabel,
        typeMetroStationLabel,
        typeNeighborhoodLabel,
        typeRegionLabel,
        typeTrainStationLabel,
        whereLabel
    };

    const datesTranslations = {
        modalTitleStartDateMessage,
        startDateLabel,
        endDateLabel,
        modalTitleEndDateMessage,
        continueButtonLabel: datesContinueButtonLabel,
        clearButtonLabel: datesClearButtonLabel,
        closeButtonLabel: datesCloseButtonLabel,
    };

    const guestsTranslations = {
        adultText,
        adultsText,
        childText,
        childrenText,
        guestText,
        guestsText,
        petsText,
        label: guestsLabel,
        modalTitle: guestsModalTitle,
        petLabel: petsText,
        petNoLabel,
        petYesLabel,
        petMessage,
        applyButtonLabel: guestsApplyButtonLabel,
        continueButtonLabel: guestsContinueButtonLabel
    };

    const submitTranslations = {
        labelText
    };

    return {
        destinationTranslations,
        datesTranslations,
        guestsTranslations,
        submitTranslations
    };
};

const getValues = (destination, search) => {
    const {
        propertyType,
        details: destinationDetails = {}
    } = destination;

    const {
        arrivalDate: startDate,
        departureDate: endDate,
        adults,
        children,
        petIncluded
    } = search;

    const filterId = !isNaN(parseInt(propertyType, 10)) ? propertyType : null;

    const searchValues = {
        filters: [filterId]
    };

    const destinationValues = {
        destination: destinationDetails.fullName,
        destinationUuid: destinationDetails.lbsId
    };

    const datesValues = {
        startDate,
        endDate
    };

    const guestsValues = {
        adults,
        children,
        petIncluded
    };

    return {
        searchValues,
        destinationValues,
        datesValues,
        guestsValues
    };
};

export {
    getOptions,
    getSettings,
    getTranslations,
    getValues
};
